import { ChangeDetectorRef, Component, HostListener, NgZone } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BaseSiteService, CmsBannerComponent, LanguageService, OccConfig, WindowRef } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, catchError, distinctUntilChanged, take, tap, throwError } from 'rxjs';
import { GigyaService } from '../../spartacus/services/gigya';
import { ContentService } from '../../spartacus/services/content.service';
import { CdcConfig, CdcJsService } from '@spartacus/cdc/root';
import { GigyaRaasComponentData } from '@spartacus/cdc/core';

@Component({
    selector: 'app-homepage-uk-banner',
    templateUrl: './homepage-uk-banner.component.html',
    styleUrls: ['./homepage-uk-banner.component.scss'],
    standalone: false
})
export class HomepageUkBannerComponent {
  baseSite: any;
  protected renderScreenSet = true;
  language$: Observable<string> | undefined;
  jsError$: Observable<boolean> | undefined;
  jsLoaded$: Observable<boolean> | undefined;
  banners: any[] = [];
  screenWidth: number = window.innerWidth;

  constructor(public component: CmsComponentData<CmsBannerComponent>,
    private sv:ContentService,
    private gigya:GigyaService,
    private cdcJsService:CdcJsService,
    protected baseSiteService: BaseSiteService,
    protected config: OccConfig,
    private cdr: ChangeDetectorRef 
    ) {
  }
  bannerNode: Observable<any> = this.component.data$;
  @HostListener('window:resize')
  onResize() {
    this.screenWidth = window.innerWidth;
    this.cdr.detectChanges();
  }
  
  getImage(media: any): string {
    const baseUrl = this.config.backend?.occ?.baseUrl || '';
    if (this.screenWidth >= 1700) {
      return baseUrl + media?.widescreen?.url;
    } else if (this.screenWidth >= 1400) {
      return baseUrl + media?.desktop?.url;
    } else if (this.screenWidth >= 1024) {
      return baseUrl + media?.tablet?.url;
    }
    return baseUrl + media?.desktop?.url;
  }
  ngOnInit(){
    localStorage.removeItem("rbapermission");
    this.component.data$.subscribe((data) =>{
      this.banners = [data];
     
    })
  }
}
